<pbc-filter [config]="config" [filter]="tage.filter$ | async" (filterChange)="tage.filter$.next($event)"></pbc-filter>
